/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ReactElement, useEffect, useMemo } from 'react';

import { Controller } from 'react-hook-form';

import { AccessSelect } from '@/components';

import { useGetMeetingTypes } from '../../hooks/use-get-meeting-types';
import { useMeetingTemplateFormContext } from '../../hooks/use-meeting-template-form-context';
import {
  generateOptions,
  groupMeetingsByCategory,
} from '../../hooks/use-meeting-types-utils';
import { setTemplateId, setTemplateStatus } from '../../store';

const MeetingTemplate = (): ReactElement => {
  const form = useMeetingTemplateFormContext();

  const { meeting_type } = form.watch();

  const { data: meetingsData } = useGetMeetingTypes();

  const meetingOptions = useMemo(() => {
    if (meetingsData?.data) {
      return generateOptions(groupMeetingsByCategory(meetingsData?.data));
    }
    return [];
  }, [meetingsData?.data]);

  useEffect(() => {
    if (meetingsData?.data && meetingsData?.data.length > 0) {
      const agenda = meetingsData.data.find(
        (meeting) => meeting.id === meeting_type,
      );
      // @ts-ignore
      setTemplateStatus(agenda?.status);
      // @ts-ignore
      setTemplateId(agenda?.id);
      // @ts-ignore
      form.setValue('agenda', agenda?.agenda);
      // @ts-ignore
      form.setValue('meeting_category', agenda?.category);
      // @ts-ignore
      form.setValue('meeting_name', agenda?.meeting_name);
    }
  }, [meeting_type]);

  return (
    <Controller
      control={form.control}
      name="meeting_type"
      render={({
        field: { ref, onChange, ...field },
        fieldState: { error },
      }) => (
        <AccessSelect
          {...field}
          label="Meeting type"
          placeholder="Select the meeting type"
          options={meetingOptions}
          optionKeys={{ label: 'name', value: 'id' }}
          inputRef={ref}
          error={Boolean(error)}
          helperText={error?.message}
          onChange={(event) => {
            onChange(event);
          }}
        />
      )}
    />
  );
};

export default MeetingTemplate;
